export default function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8 animate-fadeup">
      <div>
        <div className="label-eyebrow mb-2">{subtitle}</div>
        <h1 className="text-3xl md:text-4xl tracking-tighter font-medium" style={{fontFamily:'var(--font-heading)'}}>{title}</h1>
      </div>
      {action}
    </div>
  );
}
